import PersonIcon from "@mui/icons-material/Person";
import { Avatar, Box, Typography } from "@mui/material";
import { CustomCardBox } from "src/styledComponents";
import { getServicesCountFromCategory } from 'src/utils/helpers';

import { CustomActionCardMenu } from "../CustomActionCardMenu/CustomActionCardMenu";

import { CategoryCardProps } from "./CategoryCard.props";

export function CategoryCard ({ data, onClick }: any) {
  const servicesCount = getServicesCountFromCategory(data);

  return (
    <CustomCardBox onClick={onClick}>
      <Avatar
        variant="rounded"
        src={data?.image}
        sx={{
          width: "88px",
          height: "88px",
          borderRadius: "6px",
        }}
      >
        <PersonIcon
          sx={{
            fontSize: "45px",
          }}
        />
      </Avatar>
      <Box
        sx={{
          marginLeft: "16px",
          display: "flex",
          justifyContent: "space-between",
          width: "70%",
          flex: 1,
        }}
      >
        <Box sx={{width: "70%"}}>
          <Typography
            sx={{
              marginBottom: "16px",
              fontWeight: "500",
              textTransform: "uppercase",
              overflowWrap: "break-word",
              overflow: "hidden",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
            }}
          >
            {data?.title}
          </Typography>
          <Typography
            sx={{
              color: "#363636",
            }}
          >
            {`${data?.children?.length} subcategor${data?.children?.length === 1 ? 'y' : 'ies'}`}
          </Typography>
          <Typography
            sx={{
              color: "#363636",
            }}
          >
            {`${servicesCount} service${servicesCount === 1 ? '' : 's'}`}
          </Typography>
        </Box>
        <CustomActionCardMenu data={data}/>
      </Box>
    </CustomCardBox>
  );
}
